import { ListItemNode } from './list-item-node';

export const NoHeadingListItemNode = ListItemNode.extend({
  content: 'paragraph block*',
});
